import numberOnly from './numberOnly'
import maxLength from './maxLength'
import emailSafe from './emailSafe'
import onlyEnglish from './onlyEnglish'

export default function registerDirectives(app) {

    app.directive('number-only', numberOnly)

    app.directive('max-length', maxLength)
    app.directive('email-safe', emailSafe)
    app.directive('english', onlyEnglish)
}
